import {createViewConfig} from '@sail/engine';
import type {DialogProps} from './DialogProps';

export const DialogConfig = createViewConfig({
  props: {} as DialogProps,
  name: 'Dialog',
  defaults: {
    modality: 'modal',
    size: 'medium',
    preferredMobileDisplay: 'fullscreen-sheet',
  },
});
